import styled from 'styled-components';

import {HTMLAttributes} from 'react';

const StyledDragHandle = styled.div`
  display: flex;
  align-items: center;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

interface DragHandleProps extends HTMLAttributes<HTMLDivElement> {
  // The handle is an interactive control; assistive technology needs a name for it.
  // dnd-kit handleProps spread the same role/tabIndex when the handle is attached,
  // but the defaults below keep the contract even for a detached handle.
  'aria-label': string;
}

export function DragHandle(props: DragHandleProps) {
  return <StyledDragHandle role="button" tabIndex={0} {...props} />;
}
